import React from 'react';

const Welcome = () => (
  <div className="welcome">
    <h3>Welcome to Autzu</h3>
    <div className="welcome_content">
      <p>Let’s set your driving preferences. You can change these at any time.</p>
    </div>
  </div>
);

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/Preferences/Welcome.js